import { useEffect, useState } from 'react'

import BackIcon from '@/assets/icons/icon-back.svg'
import TelegramQRCodeImage from '@/assets/qr-Codes/qr-code-telegram.jpeg'
import WhatsappQRCodeImage from '@/assets/qr-Codes/qr-code-whatsapp.jpeg'
import { AppRoutes } from '@/utils/constants'

import { vipSupportLinks } from '../data/vip-support-links.ts'
import { VipSupportServices } from '../types'
import { ServiceCard } from './ServiceCard'
import { VipSupportCard } from './VipSupportCard.tsx'

export const VipSupport = () => {
  const [currentService, setCurrentService] = useState<VipSupportServices>(
    VipSupportServices.none,
  )

  const handleLinkClick = () => {
    setCurrentService(VipSupportServices.none)
  }

  useEffect(() => {
    // We need to return to first step of VIP Support on sidebar link click
    const sideBarLinks = document.querySelectorAll(
      `a[href='${AppRoutes.Help.VipSupport.asUrl()}']`,
    )
    const vipSupportLink = Array.from(sideBarLinks).find(
      (el) => el.textContent === 'VIP Support',
    )

    vipSupportLink?.addEventListener('click', handleLinkClick)

    return () => {
      vipSupportLink?.removeEventListener('click', handleLinkClick)
    }
  }, [])

  const renderCurrentService = () => {
    switch (currentService) {
      case VipSupportServices.none:
        return <VipSupportCard setCurrentService={setCurrentService} />
      case VipSupportServices.telegram:
        return (
          <ServiceCard
            title="Telegram"
            description="To contact us via Telegram you can scan the QR code below or click the button to open a chat with us."
            link={vipSupportLinks[VipSupportServices.telegram]}
            image={TelegramQRCodeImage}
            buttonName="Open Telegram"
          />
        )
      case VipSupportServices.whatsapp:
        return (
          <ServiceCard
            title="WhatsApp"
            description="To contact us via WhatsApp you can scan the QR code below or click the button to open a chat with us."
            link={vipSupportLinks[VipSupportServices.whatsapp]}
            image={WhatsappQRCodeImage}
            buttonName="Open WhatsApp"
          />
        )
    }
  }

  return (
    <div>
      {currentService !== VipSupportServices.none && (
        <div
          onClick={handleLinkClick}
          className="flex cursor-pointer items-center gap-2 text-sm font-medium text-primary-500"
        >
          <BackIcon />
          <span>Back to VIP Support</span>
        </div>
      )}
      <div className="flex h-[calc(85vh-128px)] w-full items-center justify-center">
        {renderCurrentService()}
      </div>
    </div>
  )
}
